var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white mt-20 tabs-palliative"},[_c('Banner'),_c('div',{},[_c('DisTab'),_c('PartnerOrganization'),_c('Faq'),_c('Newsletter'),_c('Disclaimer')],1),_c('div',{staticClass:"bge3ceff-opa"},[_c('DownloadApp'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }